import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaPhone, FaWhatsapp, FaEnvelope } from 'react-icons/fa';

import './infocontactComponent.scss'

const InfoContactComponent = () => {
    const { t } = useTranslation();

    return (
        <div className="infocontact">
            <div className="infocontact__card">
                <div className='infocontact__icon-container'>
                    <FaPhone className="infocontact__icon" />
                </div>
                <div className='infocontact__info'>
                    <h3 className="infocontact__heading">{t('contact.info.phone')}</h3>
                    <p className="infocontact__text">+34 620 512 021</p>
                </div>
            </div>

            <div className="infocontact__card">
                <div className='infocontact__icon-container'>
                    <FaWhatsapp className="infocontact__icon" />
                </div>
                <div className='infocontact__info'>
                    <h3 className="infocontact__heading">{t('contact.info.whatsapp')}</h3>
                    <p className="infocontact__text">+34 620 512 021</p>
                </div>
            </div>

            <div className="infocontact__card">
                <div className='infocontact__icon-container'>
                    <FaEnvelope className="infocontact__icon" />
                </div>
                <div className='infocontact__info'>
                    <h3 className="infocontact__heading">{t('contact.info.email')}</h3>
                    <p className="infocontact__text">info@daromainnovations.com</p>
                </div>
            </div>
        </div>
    );
};

export default InfoContactComponent;
